import { apiRequest } from '@/utils/api-request';

interface ValidateInviteProps {
  email: string;
  code: string;
}

/**
 * Validates an invite using email and code from the invite URL.
 * This is called when a user accesses an invite link like:
 * /org/invite?email=user@example.com&code=abc123
 */
export const validateInvite = async ({ email, code }: ValidateInviteProps) => {
  if (!email || !code) {
    return {
      detail: 'Invalid invite: missing email or code',
      error: 'MISSING_PARAMETERS',
    };
  }

  return await apiRequest({
    url: `/invites/validate`,
    target: 'platform',
    method: 'POST',
    body: { email: email.toLowerCase(), code },
  });
};
